export function getWidthClass(tableId: string, columnId: string): string {
  const transactionsClasses = {
    date: 'w-[10%]',
    technologies: 'w-[12%]',
    buyer: 'w-[18%]',
    seller: 'w-[18%]',
    capacity: 'w-[8%]',
    city: 'w-[14%]',
    country: 'w-[12%]',
    dropdown: 'w-[6%]',
  };

  const opportunitiesClases = {
    name: 'w-[15%]',
    technologies: 'w-[10%]',
    capacity: 'w-[10%]',
    status: 'w-[25%]',
    options: 'w-[25%]',
    country: 'w-[15%]',
  };

  const asBuyerTable = {
    status: 'w-[15%]',
    name: 'w-[20%]',
    technologies: 'w-[10%]',
    capacity: 'w-[10%]',
    location: 'w-[10%]',
    alerts: 'w-[7%]',
    details: 'w-[10%]',
  };

  const asSellerTable = {
    status: 'w-[10%]',
    name: 'w-[20%]',
    technologies: 'w-[10%]',
    capacity: 'w-[10%]',
    location: 'w-[10%]',
    eois: 'w-[7%]',
    alerts: 'w-[7%]',
    details: 'w-[10%]',
  };

  const tableWidthConfigs: Record<string, Record<string, string>> = {
    transactions: transactionsClasses,
    opportunities: opportunitiesClases,
    asBuyer: asBuyerTable,
    asSeller: asSellerTable,
  };

  const tableConfig = tableWidthConfigs[tableId];
  if (!tableConfig) {
    return 'w-auto';
  }

  return tableConfig[columnId] || 'w-auto';
}
